import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const managedReturnsIntegrationProvider = z.enum([
  "shopify",
  "commentsold",
]);

const managedReturnsIntegrationSummarySchema = z.object({
  provider: managedReturnsIntegrationProvider,
  name: z.string(),
  enabled: z.boolean(),
});

export const getManagedReturnsIntegrations = unaryRpc({
  name: "getManagedReturnsIntegrations" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    integrations: z.array(managedReturnsIntegrationSummarySchema),
  }),
});
